/**
 * Module stores prospection
 * @module app.prospection.wallet
 */
define([
    'angular',
    'modules/prospection/wallet/controllers/walletCtrl',
    'modules/prospection/wallet/controllers/modals/createBDCFirstStepCtrl',
    'modules/prospection/wallet/controllers/modals/lastBusinessCtrl',
    'modules/prospection/wallet/factories/walletService',
    'modules/prospection/wallet/factories/walletFiltersService',
    'modules/prospection/wallet/factories/walletBackendProvider'
], function(angular) {


    function prospectionWalletRouter($routeProvider) {
        $routeProvider.when('/prospection/wallet', {
            templateUrl: 'prospection/wallet/partials/wallet.html',
            controller: 'WalletCtrl',
            controllerAs: 'walletCtrl'
            // resolve: {
            //     store: ['storeService', '$route', function (storeService, $route) {
            //         return storeService.getById($route.current.params.identifiant_magasin);
            //     }]
            // }
        });

        $routeProvider.when('/prospection/old-wallet2', {
            templateUrl: 'prospection/wallet/partials/old_wallet.html',
            controller: 'WalletCtrl',
            controllerAs: 'walletCtrl'
            // resolve: {
            //     store: ['storeService', '$route', function (storeService, $route) {
            //         return storeService.getById($route.current.params.identifiant_magasin);
            //     }]
            // }
        });
    }

    prospectionWalletRouter.$inject = ['$routeProvider'];

    angular
        .module('app.prospection.wallet', [
            'app.prospection.wallet.walletCtrl',
            'app.prospection.wallet.walletService',
            'app.prospection.wallet.walletFiltersService',
            'app.prospection.wallet.walletBackend',
            'app.prospection.wallet.createBDCFirstStepCtrl',
            'app.prospection.wallet.lastBusinessCtrl'
        ])
        .config(prospectionWalletRouter);
});
